import { type CreateAssetData, createAsset } from '@/actions/assets/create';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

export function useCreateAsset() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: CreateAssetData) => {
      const result = await createAsset(data);
      if (!result.success) {
        throw new Error(result.message);
      }
      return result.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['assets'], exact: false });
      toast.success('Asset created successfully');
    },
    onError: (error: Error) => {
      toast.error(error.message || 'Failed to create asset');
    }
  });
}
